import { useNavigate } from 'react-router-dom';
import { AdvertiseLayout } from '@/components/advertise/AdvertiseLayout';
import { AdvertiseSideSummary } from '@/components/advertise/AdvertiseSideSummary';
import { AdvertiseFooterNav } from '@/components/advertise/AdvertiseFooterNav';
import { PropertyAddressAutocomplete } from '@/components/advertise/PropertyAddressAutocomplete';
import { useAdvertise } from '@/store/useAdvertise';
import { SELLERS_STEPS } from '@/config/advertiseSteps';

export default function SellersAddress() {
  const navigate = useNavigate();
  const sellers = useAdvertise((s) => s.sellers);
  const setField = useAdvertise((s) => s.setField);

  const canProceed = sellers.address && sellers.city && sellers.state && sellers.zip;

  return (
    <AdvertiseLayout
      trackLabel="Listing Boost"
      steps={SELLERS_STEPS}
      currentStepId="address"
      title="What's the address of your home?"
      subtitle="We'll try to match it to an active listing so setup is faster."
      sidebar={<AdvertiseSideSummary items={[{ label: 'Address', value: sellers.address }, { label: 'City, state', value: [sellers.city, sellers.state].filter(Boolean).join(', ') }]} />}
      footer={<AdvertiseFooterNav showBack={false} nextDisabled={!canProceed} onNext={() => navigate('/advertise/sellers/verify')} />}
    >
      <PropertyAddressAutocomplete
        value={{ address: sellers.address, city: sellers.city, state: sellers.state, zip: sellers.zip }}
        onChange={(v) => setField('sellers', v)}
      />
    </AdvertiseLayout>
  );
}
